export default __webpack_public_path__ + "static/media/login-page1400.1d13e0ca.jpg";